// extracted by mini-css-extract-plugin
module.exports = {"inputTodo":"todoform_inputTodo__1HdMR","btnSave":"todoform_btnSave__23bxj","h6":"todoform_h6__LSgds"};